
import React, { createContext, useState, useEffect } from "react";
import axios from 'axios';

// Create the context
export const MasterDataContext = createContext();
const baseURL = "https://ethiopianpassportapi.ethiopianairlines.com";

// Cache expiration time in milliseconds (24 hours)
const CACHE_EXPIRY_TIME = 24 * 60 * 60 * 1000;

export const MasterDataService = ({ children }) => {
    const [masterData, setMasterData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        debugger;
        const loadMasterData = async () => {
            try {
                // Check local storage for cached data
                const cachedData = localStorage.getItem("masterDataCollection");
                const cachedTimestamp = localStorage.getItem("masterDataTimestamp");

                if (cachedData && cachedTimestamp) {
                    const isCacheValid = Date.now() - parseInt(cachedTimestamp, 10) < CACHE_EXPIRY_TIME;
                    if (isCacheValid) {
                        setMasterData(JSON.parse(cachedData));
                        setLoading(false);
                        return;
                    }
                }

                // Fetch fresh data
                const response = await axios.get(`${baseURL}/Master/api/V1.0/MasterDatas/GetAll`);
                const data = response.data;

                // Save to state and local storage
                setMasterData(data);
                localStorage.setItem("masterDataCollection", JSON.stringify(data));
                localStorage.setItem("masterDataTimestamp", Date.now().toString());
            } catch (err) {
                console.error("Error fetching master data:", err);
                setError("Failed to load master data.");
            } finally {
                setLoading(false);
            }
        };

        loadMasterData();
    }, [baseURL]); // Ensure the effect runs if `baseURL` changes

    return (
        <MasterDataContext.Provider value={{ masterData, loading, error }}>
            {children}
        </MasterDataContext.Provider>
    );
};
